import { clearSessionHint, getSessionHint } from './sessionHint';

let cachedSessionKey = '';
let cachedStatus = null;
let pendingSessionKey = '';
let pendingRequest = null;

function sessionKeyOf(session) {
  if (typeof session === 'string') return session;
  return session?.session_key || '';
}

export function getCachedOnboardingStatus(session) {
  const key = sessionKeyOf(session);
  return key && key === cachedSessionKey ? cachedStatus : null;
}

export function setCachedOnboardingStatus(session, status) {
  const key = sessionKeyOf(session);
  if (!key || !['completed', 'pending'].includes(status)) return;
  cachedSessionKey = key;
  cachedStatus = status;
}

export function loadOnboardingStatus(session) {
  const key = sessionKeyOf(session);
  if (!key) return Promise.reject(new Error('No hay una sesión activa.'));
  const cached = getCachedOnboardingStatus(key);
  if (cached) return Promise.resolve(cached);
  if (pendingSessionKey === key && pendingRequest) return pendingRequest;

  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), 15000);
  const legacyToken = sessionStorage.getItem('syrakis_token');
  pendingSessionKey = key;
  pendingRequest = fetch('/api/onboarding', {
    credentials: 'same-origin',
    headers: { Accept: 'application/json', ...(legacyToken ? { Authorization: `Bearer ${legacyToken}` } : {}) },
    signal: controller.signal,
  }).then(async (response) => {
    const data = await response.json().catch(() => ({}));
    if (response.status === 401 || response.status === 403) {
      clearSessionHint();
      sessionStorage.removeItem('syrakis_token');
      throw new Error('La sesión ya no es válida. Inicia sesión nuevamente.');
    }
    if (!response.ok) throw new Error(data.message || data.error || 'No se pudo validar el onboarding.');
    const status = data.onboarding?.status === 'completed' ? 'completed' : 'pending';
    setCachedOnboardingStatus(key, status);
    return status;
  }).catch((error) => {
    if (controller.signal.aborted) throw new Error('La validación tardó demasiado. Comprueba tu conexión e inténtalo de nuevo.');
    throw error;
  }).finally(() => {
    window.clearTimeout(timeout);
    if (pendingSessionKey === key) {
      pendingSessionKey = '';
      pendingRequest = null;
    }
  });

  return pendingRequest;
}
